module.exports = __webpack_public_path__ + "img/bgp03.c1e62eca.jpg";